<template lang="pug">
  div(v-loading='loadingUserScope' class='govgr-card')
    el-row
      el-col(:xs='20', :sm='16', :md='14', :lg='10', :xl='8')
        el-card.box-card(shadow='hover' class='govgr-card govgr-card__body')
          .clearfix(slot='header')
            h3(align='center') Είσοδος στο eDoatap
          .text.item
            el-form.ruleForm(:model='loginForm', status-icon='', :rules='validationRules', ref='loginForm', label-width='80px')
              span(v-show='!userScope')
                el-form-item(label='Όνομα', prop='checkEmail')
                  el-input(type='name', v-model='loginForm.email', auto-complete='off')
                el-form-item(label='Κωδικός', prop='checkPassword')
                  el-input(type='password', v-model='loginForm.password', auto-complete='off',
                    v-on:keyup.enter.native="login")
                el-form-item
                  el-button(type='primary', @click='login', id='loginSubmit') Υποβολή
                  el-button(@click="resetForm('loginForm')") Σβήσιμο
              span(v-show='userScope')
                el-form-item(label='Ρόλος')
                  el-select(v-model='role', placeholder='Πιέστε για επιλογή', id="selectRole")
                    el-option(v-for="(role, index) in userScope" :key="role"
                      :label="userScopeGr[index]" :value="role"
                      v-on:keyup.enter.native="selectedRole(role)")
                  el-form-item
                    el-button(id="roleSelect", @click='selectedRole(role)', type='primary') Επιλογή Ρόλου
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'Login',
  data () {
    var validatePass = (rule, value, callback) => {
      // if (value === '') {
      //   callback(new Error('Please input the password'))
      // } else {
      //   if (this.loginForm.checkPassword !== '') {
      //     this.$refs.loginForm.validateField('checkPassword')
      //   }
      //   callback()
      // }
    }
    return {
      loginForm: {
        email: '',
        password: ''
      },
      validationRules: {
        checkPassword: [
          { validator: validatePass, trigger: 'blur' }
        ],
        checkEmail: [
          { validator: validatePass, trigger: 'blur' }
        ]
      },
      role: null,
      error: false
    }
  },
  methods: {
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          alert('submit!')
        } else {
          return false
        }
      })
    },
    resetForm (formName) {
      this.$refs[formName].resetFields()
      this.loginForm.email = ''
      this.loginForm.password = ''
    },
    selectedRole (role) {
      const noChatroomsRoles = [
        'Auditor',
        'TemporaryUser',
        'DocutracksUser',
        'CouncilMember',
        'SpecialReappraisalBoardMember'
      ]
      const externalChatroomsRoles = ['SpecialProponent', 'PreChecker']
      console.log('role', role)
      if (role !== null) this.$store.dispatch('selectedRole', role)
      if (!noChatroomsRoles.includes(role)) this.$store.dispatch('GET_CHATROOMS')
      if (externalChatroomsRoles.includes(role)) this.$store.dispatch('GET_EXTERNAL_CHATROOMS')
    },
    login () {
      this.$store.dispatch('login', { name: this.loginForm.email, password: this.loginForm.password })
    }
  },
  computed: {
    ...mapGetters({
      currentUser: 'currentUser',
      userScope: 'userScope',
      userScopeGr: 'userScopeGr',
      loadingUserScope: 'loadingUserScope'
    })
  }
}
</script>

<style lang="scss" scoped>
.el-card {
  background-color: #b3c0d1;
}
.el-card__body {
  padding: 20px;
}
.el-row {
  display: flex;
  justify-content: center;
  margin-top: 60px;
  margin-bottom: 60px;
}
.bg-purple {
  background: #d3dce6;
}
body {
  background: rgb(255, 255, 255);
}

.login-wrapper {
  background: #fff;
  width: 70%;
  margin: 12% auto;
}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue